import { loaderAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { GetServicesSettingsThunk } from "./GetServicesSettingsThunk";

export const RemoveSpecializationThunk = (args) => async (dispatch, getState) => {
    const { user } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('specialization_id', args.specialization_id);

        const response = await api({ data: formData, link: 'remove_specialization' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Запрашиваем обновлённые данные
            dispatch(GetServicesSettingsThunk());

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};